import script from "./MainTelInput.vue?vue&type=script&setup=true&lang=js"
export * from "./MainTelInput.vue?vue&type=script&setup=true&lang=js"

import "./MainTelInput.vue?vue&type=style&index=0&id=29ca41dc&lang=scss"

const __exports__ = script;

export default __exports__